import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 54px 28px;
        gap: 36px;
    `,

    "ExamList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
    "ExamElement": styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${({ theme }) => theme.color["grey2"]};
    `,
    "ExamTitleDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;

        & > h1 {
            ${({ theme }) => theme.font["large-semibold"]};
        }

        & > h2 {
            ${({ theme }) => theme.font["xsmall-medium"]};
        }

        & > p {
            ${({ theme }) => theme.font["tiny-regular"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,
    "TakingButtonDiv": styled.div`
        width: 72px;
        min-width: 72px;
    `,
}